function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import Colors from "styles/colors";
import AssetComponent from "components/core/asset/asset-component";
import { withGenericConfig } from "contexts/generic-config-context";
import { AUTO } from "constants/cloudinary-asset-qualities";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { trackEvent } from "/services/bigbrain-service";
import { ASSET_COMPONENT_IS_FULLY_VISIBLE } from "constants/bigbrain-event-types";
import { withSegmentsData } from "contexts/segment-context";
import { StyledRegularAssetComponent } from "./regular-asset-component.scss";
const RegularAssetComponent = (props)=>{
    const { isMobileOrTabletBrowser, backgroundColor, width, mobileWidth, position, asset, assetQuality, useDynamicAsset, hideControls, fullWidth, useWindowMask, minHeight, segmentNumber } = props;
    const finalWidth = isMobileOrTabletBrowser && mobileWidth ? mobileWidth : width;
    const widthInPercentage = finalWidth ? `${finalWidth}%` : "auto";
    const [assetRef, assetFullyInView] = useInView({
        threshold: 1.0,
        triggerOnce: true
    });
    useEffect(()=>{
        if (asset && assetFullyInView) {
            const { image, video } = asset;
            trackEvent(ASSET_COMPONENT_IS_FULLY_VISIBLE, {
                kind: (image === null || image === void 0 ? void 0 : image.src) || (video === null || video === void 0 ? void 0 : video.src),
                info1: segmentNumber
            });
        }
    }, [
        assetFullyInView
    ]);
    return /*#__PURE__*/ _jsx(StyledRegularAssetComponent, {
        className: "regular-asset-component",
        style: {
            backgroundColor: Colors[backgroundColor],
            minHeight
        },
        ref: assetRef,
        children: /*#__PURE__*/ _jsx("div", {
            className: classnames("asset-component-wrapper", position, {
                "full-width": fullWidth
            }),
            children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, asset), {
                assetQuality: assetQuality,
                useDynamicAsset: useDynamicAsset,
                hideControls: hideControls,
                width: widthInPercentage,
                convertGifToVideo: true,
                className: "regular-asset-image-wrapper",
                imageClassName: "regular-asset-image",
                useWindowMask: useWindowMask
            }))
        })
    });
};
RegularAssetComponent.defaultProps = {
    width: 100,
    position: "center",
    asset: {
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/asset/timeline-view.png"
        }
    },
    assetQuality: AUTO,
    fullWidth: false
};
export default withSegmentsData(withGenericConfig(RegularAssetComponent));
